import React, { ReactElement } from 'react';

import { Moment } from 'moment';

interface MonthlyTimeSpanProps {
  date: Moment;
  onClick: () => void;
}

function MonthlyTimeSpan({ date, onClick }: MonthlyTimeSpanProps): ReactElement {
  const year = date.format('YYYY');
  const month = date.format('MMM');

  return (
    <div className="c-calendar__time-span-date" data-testid="calendar-time-span-date" onClick={onClick}>
      <div className="c-calendar__year" data-testid="calendar-time-span-year">{year}</div>
      <div className="c-calendar__month" data-testid="calendar-time-span-month">{month}</div>
    </div>
  );
}

export default MonthlyTimeSpan;
